import React from 'react'

import { Box, Button, Text } from '@domain-group/suit-theme'

interface OrderScreenFooterProps {
  children: React.ReactNode,
  href: string,
}

const OrderScreenFooter = (props: OrderScreenFooterProps) => {
  const { children, href } = props

  return (
    <Box alignItems="center" marginBottom="large" padding="large" variant="white">
      <Text>
        {children}
      </Text>

      <Button
        // @ts-expect-error TS2322
        as="a"
        buttonStyle="secondaryUtility"
        href={href}
        marginLeft="auto"
        size="medium"
        width="auto"
      >
        View Orders
      </Button>
    </Box>
  )
}

export default OrderScreenFooter
